import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canSeeMenu, firstAllowedPath } from "../lib/menu";

export default function ProtectedRoute({ children, roles, menuKey }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[color:var(--text-muted)] text-sm">Caricamento…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (roles && !roles.includes(user.role) && user.role !== "admin") {
    return <Navigate to="/" replace />;
  }
  if (menuKey && !canSeeMenu(user, menuKey)) {
    const fallback = firstAllowedPath(user);
    if (!fallback || fallback === location.pathname) {
      return (
        <div className="min-h-[50vh] flex items-center justify-center p-8" data-testid="no-access-page">
          <div className="text-center">
            <div className="text-lg font-bold mb-1" style={{ fontFamily: "Manrope" }}>Accesso non consentito</div>
            <div className="text-sm" style={{ color: "var(--text-muted)" }}>
              Non hai i permessi per questa sezione. Contatta l'amministratore.
            </div>
          </div>
        </div>
      );
    }
    return <Navigate to={fallback} replace />;
  }
  return children;
}
